export default __webpack_public_path__ + "static/media/icn_rabet.dd76a9cf.svg";